export class Version {
  author_name?: string;
  dt?: string;
  nature_name?: string;
  participant_name?: string;
  author_surname?: string;
  nature_description?: string;
  id?: number;
  custodian_name?: string
  [key: string]: any;
}
